import { OrgId } from "@hex/common";

import { Routes } from "../../route/routes";

interface SsoLoginUrlArgs {
  authQueryParams?: Record<string, string>;
  orgId: OrgId;
}

interface StartSsoLoginArgs {
  authQueryParams: Record<string, string>;
  embedded: boolean;
  onComplete: () => void;
  onSubmit: () => void;
  orgId: OrgId;
}

export function getSsoLoginUrl({
  authQueryParams,
  orgId,
}: SsoLoginUrlArgs): string {
  return Routes.SSO_AUTH.getUrl({
    orgId,
    queryParams: authQueryParams,
  });
}

export function redirectToSsoLogin(args: SsoLoginUrlArgs): void {
  window.location.href = getSsoLoginUrl(args);
}

export function startSsoLogin({
  authQueryParams,
  embedded,
  onComplete,
  onSubmit,
  orgId,
}: StartSsoLoginArgs): void {
  onSubmit();

  if (embedded) {
    const ssoUrl = getSsoLoginUrl({ authQueryParams, orgId });
    window.open(ssoUrl, "_blank");
    onComplete();
  } else {
    redirectToSsoLogin({ authQueryParams, orgId });
  }
}
